<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="2" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">单价信息</b-th>
          <b-th colspan="2" style="text-align: center">出勤情况</b-th>
          <b-th colspan="3" style="text-align: center">工作量</b-th>
          <b-th colspan="2" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(unitPrice)="data">
        {{ formatAmount(data.item.unitPrice) }}
      </template>

      <template v-slot:cell(attendanceUnit)="data">
        {{ data.item.attendanceUnitLabel }}
      </template>

      <template v-slot:cell(workloadQty)="data">
        {{ Number(data.item.workloadQty).toFixed(1) }}
      </template>

      <template v-slot:cell(workloadUnit)="data">
        {{ data.item.workloadUnitLabel }}
      </template>

      <template v-slot:cell(subtotal)="data">
        {{ formatAmount(data.item.subtotal) }}
      </template>

      <template v-slot:cell(amount)="data">
        {{ formatAmount(data.item.amount) }}
      </template>

      <template v-slot:cell(remarks)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ApmsRegLaborEmploymentDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'feeItemName', label: '费项名称', width: '150px'},
        {key: 'unitPrice', label: '单价', width: '110px'},
        {key: 'priceUnit', label: '单位', width: '110px'},
        {key: 'attendanceQty', label: '数量', width: '100px'},
        {key: 'attendanceUnitLabel', label: '单位', width: '100px'},
        {key: 'workloadQty', label: '数量', width: '110px'},
        {key: 'workloadUnitLabel', label: '单位', width: '110px'},
        {key: 'subtotal', label: '小计', width: '100px'},
        {key: 'amount', label: '金额（元）', width: '110px'},
        {key: 'remarks', label: '备注', width: '130px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    showDetail(content) {
      if (!content) {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      dataList.map((item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
  }
}
</script>

<style scoped>
</style>
